var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"no-data":""}},[(_vm.src)?_c('ImageAsset',{attrs:{"url":_vm.src,"bg-color":'transparent'}}):_vm._e(),_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }